<template>
  <div class="header-section">
    <div class="header-content">
      <!-- Title and Summary Row -->
      <div class="header-top-row">
        <div class="title-section">
          <h1 class="main-title">Select Your Province</h1>
          <p class="subtitle">
            Select a province to manage orders and services
          </p>
        </div>

        <!-- Order Summary -->
        <div class="order-summary-right">
          <v-card class="order-summary-card" color="#fddf00" elevation="3">
            <v-card-text class="order-summary-content">
              <div class="order-summary-item">
                <v-icon color="black" size="x-large"
                  >mdi-shopping-outline</v-icon
                >
                <div class="order-summary-text">
                  <h3 class="order-total">{{ totalOrderCount }}</h3>
                  <p class="order-label">Total Orders</p>
                </div>
              </div>

              <div class="order-summary-item">
                <v-icon color="black" size="x-large"
                  >mdi-map-marker-multiple</v-icon
                >
                <div class="order-summary-text">
                  <h3 class="order-total">{{ activeProvincesCount }}</h3>
                  <p class="order-label">Active Provinces</p>
                </div>
              </div>

              <div class="order-summary-item">
                <v-icon
                  color="black"
                  size="x-large"
                  :class="{ 'pulse-animation': isUpdating }"
                >
                  mdi-refresh
                </v-icon>
                <div class="order-summary-text">
                  <h3 class="order-total">{{ lastUpdateTime || "--:--" }}</h3>
                  <p class="order-label">Last Update</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    totalOrderCount: {
      type: Number,
      default: 0,
    },
    activeProvincesCount: {
      type: Number,
      default: 0,
    },
    lastUpdateTime: {
      type: String,
      default: "",
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.header-section {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.header-top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 2rem;
}

.title-section {
  flex: 1;
  text-align: left;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: left;
  text-shadow: 2px 2px 4px rgba(117, 117, 117, 0.5);
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  text-align: left;
  margin-bottom: 0;
}

.order-summary-right {
  flex-shrink: 0;
  min-width: 400px;
}

.order-summary-card {
  border-radius: 12px;
  border: 2px solid #f39c12;
}

.order-summary-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
}

.order-summary-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.order-summary-text {
  text-align: left;
}

.order-total {
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
  margin: 0;
}

.order-label {
  font-size: 0.9rem;
  color: #333;
  margin: 0;
  font-weight: 500;
}

.pulse-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .header-top-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .title-section {
    text-align: center;
    margin-bottom: 1rem;
  }

  .main-title {
    font-size: 2rem;
    text-align: center;
  }

  .subtitle {
    text-align: center;
  }

  .order-summary-right {
    min-width: 100%;
  }

  .order-summary-content {
    flex-direction: column;
    gap: 1rem;
  }

  .order-summary-item {
    justify-content: center;
  }
}
</style>
